import React from 'react';
import PropTypes from 'prop-types';

class Fieldset extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        legend: PropTypes.string,
        noBorder: PropTypes.bool,
        className: PropTypes.string,
    };

    static defaultProps = {
        legend: null,
        noBorder: false,
        className: '',
    };

    render() {
        const { children, legend, className } = this.props;

        let fieldsetClassName = ['fieldset', 'fieldset--editable'];

        if (className) {
            fieldsetClassName.push(className);
        }

        if (this.props.noBorder) {
            fieldsetClassName.push('fieldset--no-border');
        }

        fieldsetClassName = fieldsetClassName.join(' ');

        return (
            <fieldset className={fieldsetClassName}>
                <legend className="fieldset__legend">{legend}</legend>
                {React.Children.map(children, child => (
                    <div className="fieldset__formrow">{child}</div>
                ))}
            </fieldset>
        );
    }
}

export default Fieldset;



// WEBPACK FOOTER //
// ./src/frontend/components/Fieldset.jsx